<div class="page-cont col-12">
  <div class="title-cont">
    <h4 class="title-h4-blue">{{ title }}</h4>
    <div class="exportar-cont">
      <app-exportar
        [data]="insuranceData"
        (exportar)="onExportar($event)"
      ></app-exportar>
    </div>
  </div>
  <hr />
  <div class="campos-cont">
    <app-campos
      [tipo]="'descargas'"
      [camposVisibles]="['desde', 'hasta', 'policy', 'cliente']"
      [camposObligatorios]="['desde', 'hasta']"
      [defaultDesde]="defaultDesde"
      [defaultHasta]="defaultHasta"
      [rangeInMonths]="3"
      [applyDateRangeLimit]="false"
      (filterChange)="onFilterChange($event)"
    ></app-campos>
  </div>
</div>

<app-insurance-table
  [data]="insuranceData"
  [config]="tableConfig"
  [configExport]="tableConfigExport"
  (actionClick)="onPrintDownload($event)"
  (loadDocuments)="loadDocuments($event)"
  (printEndorsement)="printEndorsements($event)"
  [mensajeNoData]="mensajeNoData"
  [error]="errorStatus"
  [itemsPerPage]="pageSize"
  [serverSidePagination]="true"
  [totalRecordsFromServer]="totalRecordsFromServer"
  [totalPagesFromServer]="totalPagesFromServer"
  (pageChange)="onPageChange($event)"
></app-insurance-table>

@if(isFoundPrint) {
<div class="request-notification-modal">
  <div class="modal-container">
    <img src="assets/warning.svg" alt="warning icon" />
    <h3 class="mb-4">
      <strong>Documentos no disponibles</strong>
    </h3>
    <p>{{ noDocumentsAviableMessage }}</p>
    <button (click)="isFoundPrint = false" class="btn-m-new mt-3">
      Cerrar
    </button>
  </div>
</div>
}

@if(preventDownload) {
<div class="request-notification-modal">
  <div class="modal-container">
    <img src="assets/warning.svg" alt="warning icon" />
    <h3 class="mb-4">
      <strong>Documentos no disponibles</strong>
    </h3>
    <p>Los documentos de Condiciones Particulares para este ramo no están disponibles.</p>
    <button (click)="preventDownload = false" class="btn-m-new mt-3">
      Cerrar
    </button>

  </div>
</div>
}
